import React from 'react'
import { BusyButton } from '@ztechapps/webui.button'
import { Alert, ShowIf } from '@ztechapps/webui.util'
import { useFormikContext } from 'formik'

export const ForgotPasswordButton = () => {
  const { isValid, dirty, status, isSubmitting } = useFormikContext()

  const submittedSuccess = status === 'success'

  return (
    <React.Fragment>
      <ShowIf condition={submittedSuccess}>
        <Alert type="success">
          <strong>Reset password successfully! </strong>
          <p>Please check your email for instruction on how update the password.</p>
        </Alert>
      </ShowIf>

      <div className="form-group ">
        <BusyButton type="submit" bsStyle="primary" isBusy={isSubmitting} disabled={!isValid || !dirty}>
          Reset Password
        </BusyButton>
      </div>
    </React.Fragment>
  )
}
